import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { formatDistance } from '../../../../../_shared/helpers/formatting';
import WatchListButton from '../../../../WatchlistButton';
import Controls from '../../../Controls';
import {
  TradeState,
  ListVariant,
  FilterNames
} from '../../../../../_shared/types/trade';
import { BidSource } from '../../../../../_shared/types/auction';
import FloorMeter from '../../../../FloorMeter';
import useWatchlist from '../../../../../_shared/hooks/useWatchlist';

import {
  StyledContent,
  StyledContentHeader,
  StyledDistance,
  StyledControls,
  StyledFloorMeterBadges
} from './Styles';

const Content = ({ tradeSummary, tradeState, onImpound, setBidContext }) => {
  const {
    id: tradeId,
    mileage,
    odometerType,
    transmission,
    auctionSummary,
    isAsIs,
    isWatchlisted,
    isImpounded,
    tradeVehicleSummary: { vehicleSummary },
    vin,
    tradeFloorPrice
  } = tradeSummary;

  const activeFilter = useSelector(
    state => state?.filter?.activeFilter,
    shallowEqual
  );

  const [watchList, setWatchList] = useWatchlist(
    tradeId,
    tradeState,
    isWatchlisted
  );

  const onShouldShowTrade = shouldShow => {
    if (!shouldShow) {
      onImpound(tradeId);
    }
  };

  return (
    <StyledContent tradeState={tradeState}>
      <StyledContentHeader>
        <StyledDistance>
          {formatDistance(mileage)} {odometerType} | {transmission}
        </StyledDistance>
        <StyledControls>
          {!(activeFilter?.id === FilterNames.impound.id || isImpounded) && (
            <WatchListButton
              variant="mini"
              auctionId={auctionSummary?.id}
              isAsIs={isAsIs}
              isWatchlisted={watchList}
              modelName={vehicleSummary?.model?.displayName}
              pageSource={BidSource.GRID_VIEW}
              tradeId={tradeId}
              tradeState={tradeState}
              trim={vehicleSummary?.trim}
              vin={vin}
              year={vehicleSummary?.modelYear}
              setParentWatchList={setWatchList}
            />
          )}
          <Controls
            auctionSummary={auctionSummary}
            setBidContext={setBidContext}
            setShouldShowTrade={onShouldShowTrade}
            tradeId={tradeId}
            watchList={watchList}
            variant={ListVariant.GRID}
            vin={vin}
          />
        </StyledControls>
      </StyledContentHeader>
      {tradeState === TradeState.active && (
        <StyledFloorMeterBadges>
          <FloorMeter
            testId="replace-soon"
            tradeId={tradeId}
            variant={ListVariant.GRID}
            isFloorPriceMet={tradeFloorPrice?.isFloorPriceMet}
            hasFloorPrice={tradeFloorPrice?.hasFloorPrice}
            isCloseToFloorPrice={tradeFloorPrice?.isCloseToFloorPrice}
          />
        </StyledFloorMeterBadges>
      )}
    </StyledContent>
  );
};

export default Content;
